var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VList',{staticClass:"py-0 px-0",class:{'close' : _vm.miniVariant},attrs:{"dense":"","dark":"","color":"transparent"}},_vm._l((_vm.items),function(ref){
var exact = ref.exact;
var icon = ref.icon;
var link = ref.link;
var title = ref.title;
return _c('VListItem',{key:title,staticClass:"menu-item",attrs:{"link":"","to":link,"exact":exact},on:{"click":function($event){return _vm.itemSelect()}}},[_c('VListItemContent',{staticClass:"d-block"},[_c('VListItemTitle',{class:_vm.miniVariant
          ? 'd-block' : 'd-flex align-center flex-row justify-start flex-nowrap'},[_c('div',{staticClass:"menu-icon",domProps:{"innerHTML":_vm._s(icon)}}),_vm._v(" "+_vm._s(_vm.$t(title))+" ")])],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }